module.exports = __webpack_public_path__ + "static/img/cMRId2.12168206.png";